module.exports = __webpack_public_path__ + "img/train4.68ef9b6d.jpg";